<template>
  <v-footer class="black">
    <v-card flat dark tile width="100%" class="black lighten-1 text-center">
      <v-card-text>
        <v-btn
          v-for="(route, n) in routes"
          :key="n"
          class="mx-4"
          icon
          :href="route.link"
        >
          <v-icon size="24px">{{ route.icon }}</v-icon>
        </v-btn>
      </v-card-text>
      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — <strong>Vira Designs</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    routes: [
      {
        icon: "fab fa-facebook",
        link: "https://www.facebook.com/chunvira.ly.3"
      },
      { icon: "fab fa-instagram", link: "https://www.instagram.com/notvira/" },
      {
        icon: "fab fa-linkedin",
        link: "https://www.linkedin.com/in/chunvira-ly-792ab419b/"
      },
      { icon: "fab fa-github", link: "https://github.com/lychunvira18" }
    ]
  })
};
</script>

<style></style>
